import { MultiSelectOutlined } from '@amelio/ui-library';

import type {
    OnSelectCompanyAttributeOption,
    SelectedFilters,
} from '@/hooks/filters/useCompanyAttributesFilters';
import type { MultiSelectAccent } from '@amelio/ui-library';

import { resolveSelectedValueIds } from '@/components/AudienceFilterList/audienceFilterValues';
import { decodeAndSanitize } from '@/utils/htmlSanitizer';
import { getLocalizedText } from '@/utils/localization';

interface AttributeSelectListProps {
    attribute: OnSelectCompanyAttributeOption['attribute'];
    filters: SelectedFilters;
    accent?: MultiSelectAccent;
    isReadOnly?: boolean;
    dataTestId?: string;
    selectCompanyAttributeOption: (params: OnSelectCompanyAttributeOption) => void;
}

export const AttributeSelectList = ({
    attribute,
    filters,
    accent,
    isReadOnly = false,
    dataTestId,
    selectCompanyAttributeOption,
}: AttributeSelectListProps) => {
    const selectedValues = resolveSelectedValueIds({ attribute, filters });

    return (
        <div
            key={attribute.name}
            className={'inline-block w-fit max-w-full min-w-[12.5rem] shrink-0'}
        >
            <MultiSelectOutlined
                accent={accent}
                dataTestId={dataTestId}
                options={(attribute.values ?? []).map((value) => ({
                    label: decodeAndSanitize(
                        'names' in value ? getLocalizedText(value.names) : value.name,
                    ),
                    value: value.id,
                }))}
                onChange={(value) => selectCompanyAttributeOption({ value, attribute })}
                showSelection={true}
                label={decodeAndSanitize(attribute.name)}
                values={selectedValues}
                readOnly={isReadOnly}
            />
        </div>
    );
};
